import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { DefaultService } from '@codegen/service';
import { EventRequest } from '@codegen';
import { EMPTY, timer } from 'rxjs';
import {
  contractsOrderConsultation,
  contractsOrderConsultationSuccess,
  proposalOrderConsultation,
  proposalOrderConsultationSuccess,
} from './event.action';
import { ConsultationOrderedModalComponent } from '../../modals/consultation-ordered-modal/consultation-ordered-modal.component';

@Injectable()
export class EventEffects {
  private actions$ = inject(Actions);
  private resourceService = inject(DefaultService);
  private dialog = inject(MatDialog);

  public ProposalOrderConsultation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(proposalOrderConsultation),
      map(data => data.applicationId),
      switchMap(applicationId => {
        return this.resourceService
          .informationFinOrgsEvent({
            eventId: EventRequest.EventIdEnum.ApplicationConsultation,
            params: {
              applicationId,
            },
          })
          .pipe(
            map(() => proposalOrderConsultationSuccess()),
            catchError(() => EMPTY)
          );
      })
    )
  );

  public ContractsOrderConsultation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(contractsOrderConsultation),
      map(data => data.contractId),
      switchMap(contractId => {
        return this.resourceService
          .informationFinOrgsEvent({
            eventId: EventRequest.EventIdEnum.ContractConsultation,
            params: {
              contractId,
            },
          })
          .pipe(
            map(() => contractsOrderConsultationSuccess()),
            catchError(() => EMPTY)
          );
      })
    )
  );

  public showContractsConsultationSuccessDialog$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          contractsOrderConsultationSuccess,
          proposalOrderConsultationSuccess
        ),
        tap(() => {
          const modalRef = this.dialog.open(ConsultationOrderedModalComponent, {
            autoFocus: false,
          });

          timer(3000).subscribe(() => modalRef.close());
        })
      ),
    { dispatch: false }
  );
}
